export const SET_USER_TOKEN = (state, accessToken) => {
  state.authToken = accessToken;
};

export const SET_GUEST_BUYER = (state, isGuestBuyer) => {
  state.isGuestBuyer = isGuestBuyer;
};

export const SET_CLIENT_TOKEN = (state, clientToken) => {
  state.clientToken = clientToken;
  window.localStorage.setItem('clientToken', JSON.stringify(state.clientToken));
};

export const SET_EXPIRES_IN = (state, expiresIn) => {
  state.expiresIn = expiresIn;
  window.localStorage.setItem('expiresIn', state.expiresIn);
};

// export const SET_USER_DATA = (state, userData) => {
//   state.pdv = userData.pdv;
//   state.pos = userData.pos;
//   Vue.http.headers.common.PDV = userData.pdv;
//   Vue.http.headers.common.POS = userData.pos;
// };

export const SET_EVENT_POS = (state, pos) => {
  state.pos = pos;
  // Vue.http.headers.common['pos'] = pos;
  // axios.defaults.headers.common['pos'] = pos
};

export const SET_EVENT_PDV = (state, pdv) => {
  state.pdv = pdv;
  // Vue.http.headers.common['pdv'] = pdv;
  // axios.defaults.headers.common['pdv'] = pdv
};

export const SET_API_URL = (state, apiUrl) => {
  state.api_url = apiUrl;
};

export const SET_STORE_CONFIGS = (state, storeConfigs) => {
  state.storeConfigs = storeConfigs;
};

export const SET_STORE = (state, store) => {
  state.store = store;
};

export const SET_LOGINPOS_DATA = (state, data) => {
  state.loginPosData = data;
};

export const DESTROY_USER_TOKEN = state => {
  state.authToken = null;
  state.clientId = null;
  state.pdv = null;
  state.pos = null;
  state.userProps = {
    clientID: null,
    email: '',
    name: '',
    lastname: '',
    ddi: '55',
    country: '',
    notBrazillian: false,
    document: '',
    phone: '',
    ddd: '',
    password: '',
  };
  state.signSteps = {
    logged: false,
    signForm: true,
    step: 0,
  };
  localStorage.clear();
};

export const SET_LOGIN_ERROR = state => {
  state.loginError = {
    title: 'Erro',
  };
};

export const SET_USER_PROPS = (state, data) => {
  state.userProps = { ...data };
  window.localStorage.setItem('userProps', JSON.stringify(data));
};

export const SET_USER_BILLET_PROPS = (state, data) => {
  state.userBilletProps = { ...data };
};

export const CLEAR_USER_PROPS = state => {
  const data = {
    clientID: null,
    email: '',
    name: '',
    lastname: '',
    ddi: '55',
    country: '',
    notBrazillian: false,
    document: '',
    phone: '',
    ddd: '',
    password: '',
  };
  SET_USER_PROPS(state, data);
};

export const SET_SIGN_STEPS = (state, data) => {
  Object.assign(state.signSteps, data);
  window.localStorage.setItem('signSteps', JSON.stringify(state.signSteps));
};
